import React, { useMemo } from 'react';
import DateRangeField from '../../../../controllers/base/DateRangeField';
import { fieldNames } from '../../constants';
import { useDisabledDate } from '../../hooks/disabledDate';
import styles from './index.module.scss';

const { usePickerSettings } = DateRangeField;

const Period = () => {
  const disabledDate = useDisabledDate();

  const config = useMemo(() => createConfig(disabledDate), [disabledDate]);

  const pickerSettings = usePickerSettings(...config);

  return (
    <DateRangeField pickerSettings={pickerSettings} className={styles.root} />
  );
};

export default Period;

function createConfig(disabledDate) {
  const startData = {
    name: fieldNames.startDate,
    label: 'Дата начала',
    rules: { required: 'Укажите дату начала' },
    getDisabledDate: disabledDate,
  };

  const endData = {
    name: fieldNames.endDate,
    label: 'Дата окончания',
    rules: { required: 'Укажите дату окончания' },
    getDisabledDate: disabledDate,
  };

  return [startData, endData];
}
